<template>
    <div>
        <hts-drawer
            v-model="visible"
            size="large"
            :rules="rulesEditBusiness"
            :submit="handleSubmit"
            :title="$t('labels.businessModule.edit')"
            @close="closeOverSide">
            <hts-card :title="$t('labels.generalInformation')">
                <div
                    class="grid gap-4"
                    :class="columnClass">
                    <hts-form-input
                        v-model="dataEdit.name"
                        :label="$t('labels.businessModule.name')"
                        :required="true"
                        :color="props.color"
                        name="businessModule.name"
                        prop="businessModule.name" />
                    <hts-admincp-select-task
                        v-model="dataEdit.tasks"
                        :selected-multiple="taskSelected"
                        required
                        multiple
                        :label="$t('labels.taskList')"
                        name="taskList"
                        prop="taskList"
                        key-id="_id"
                        key-label="name"
                        :filterable="true"
                        :clearable="true" />
                    <hts-form-input
                        v-model="dataEdit.description"
                        :label="$t('labels.description')"
                        :color="props.color"
                        name="description"
                        prop="description" />
                </div>
            </hts-card>
        </hts-drawer>

        <hts-modal
            :show="passDuplicateTask"
            :type="percentDuplicate !== 100 ? 'confirm' : ''"
            title=""
            :content="
                percentDuplicate !== 100
                    ? $t('labels.contentDuplicateTask', { business: nameBusinessDuplicate || '', name: dataEdit.name || '' })
                    : $t('labels.contentTheSameTask', { business: nameBusinessDuplicate || '', name: dataEdit.name || '' })
            "
            @close="passDuplicateTask = false"
            @confirm="handleSubmit" />
    </div>
</template>
<script setup lang="ts">
import { initEditBusiness, rulesEditBusiness } from '../imports/form'
import { $api } from '#imports'

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const emits = defineEmits(['close', 'refreshTables', 'update:show'])

const visible = ref(false)
const dataEdit: { [key: string]: any | null } = ref({ ...initEditBusiness })
const taskSelected = ref({} as { [key: string]: string })
const passDuplicateTask = ref(false)
const nameBusinessDuplicate = ref('')
const percentDuplicate = ref(0)

const open = async (id: string) => {
  visible.value = true
  await getData(id)
}

const closeOverSide = () => {
  visible.value = false
  resetField()
}

const getData = async (id: string) => {
  const api = $urlAdmin.business.getById
  const data: any = await $api(api, { uriParams: { ID: id } })
  const resData: any = data?.data?.value
  if (resData?.success) {
    dataEdit.value = resData.data
    taskSelected.value = resData.data.tasks.map((task: any) => {
      return {
        _id: task._id,
        name: task.name
      }
    })
    dataEdit.value.tasks = resData.data.tasks.map((task: any) => {
      return task._id
    })
  }
}

const resetField = () => {
  dataEdit.value = { ...initEditBusiness }
  dataEdit.value.task = []
  passDuplicateTask.value = false
  const nameBusinessDuplicate = ref('')
  const percentDuplicate = ref(0)
}

const handleSubmit = async () => {
  const api = $urlAdmin.business.edit
  const dataE = { ...dataEdit.value }
  const data: any = await $api(api, {
    uriParams: { ID: dataE._id },
    body: {
      ...dataE,
      passDuplicateTask: passDuplicateTask.value
    }
  })
  const resData: any = data?.data?.value

  if (resData?.success) {
    if (resData.data.duplicate) {
      passDuplicateTask.value = true
      nameBusinessDuplicate.value = resData.data.name
      percentDuplicate.value = resData.data.percent
    } else {
      emits('refreshTables')
      process.client && $toast().success($t('labels.editBusinessSuccess'))
      closeOverSide()
      resetField()
    }
  }
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

defineExpose({
  open
})
</script>
